import { render, staticRenderFns } from "./addemailConf.vue?vue&type=template&id=c1ace636&scoped=true&"
import script from "./addemailConf.vue?vue&type=script&lang=js&"
export * from "./addemailConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ace636",
  null
  
)

export default component.exports